/**
 * DB me kuch fields ALL CAPS me store hain — jaise Website_LexPractice.PracticeArea
 * ("PROPERTY RELATED DISPUTES") aur OurProfile.Advocate ("ADVOCATE-ON-RECORD").
 *
 * Naye design me headings serif font me hain jahan all-caps bhaari aur padhne me
 * mushkil lagta hai, isliye display ke waqt title case kar dete hain.
 * Data ko haath nahi lagaya jaata — ye sirf render-time formatting hai.
 */
export function titleCase(value: string) {
  return value
    .toLowerCase()
    .replace(/\b([a-z])/g, (m) => m.toUpperCase())
    .replace(/\b(And|Of|To|For|In|On|The|A|An)\b/g, (m) => m.toLowerCase())
}

/**
 * Website_LexAboutUs.Description ek hi column me teen paragraph rakhta hai,
 * jo aapas me newline se alag hain. HTML newline ko space maan leta hai, isliye
 * purani site par ye sab ek lambi deewar jaisa paragraph ban jaata tha.
 *
 * Yahan usi text ko wapas paragraphs me tod dete hain — content bilkul wahi
 * rehta hai, bas padhne layak dikhta hai.
 */
export function paragraphs(value: string | null | undefined): string[] {
  if (!value) return []
  return value
    .split(/\r?\n+/)
    .map((line) => line.trim())
    .filter(Boolean)
}

/** `tel:` href ke liye — space, dash, brackets hata kar sirf digits/+ rakhta hai. */
export function telHref(phone: string) {
  return `tel:${phone.replace(/[^\d+]/g, '')}`
}
